import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/goods/',
    component:layout,
    children:[
        {name: '保险列表', path: 'index', component: ()=>_import('index')},
		{name: '保险分组', path: 'group', component: ()=>_import('group')},
		{name: '保险分类', path: 'category', component: ()=>_import('category')},
        // add route here
    ]
}